<template>
  <div class="layer">
    <div v-if="coupon" class="inner">
      <button type="button" class="btnClose" @click="close"><span class="blind">close</span></button>
      <h2 class="layerTitle">{{locale.coupon}}</h2>
      <div class="couponDetail">
        <div class="info">
          <!-- 쿠폰명 -->
          <div class="innerItem isRequired">
            <div class="innerTitle setLabel">{{locale.name}}</div>
            <input type="text" class="input" v-model="coupon.title">
          </div>
          <!-- //쿠폰명 -->
          <!-- 제목 (display) -->
          <div class="mb15">
            <div class="innerTitle setLabel">{{locale.title}}</div>
            <div class="siteTitle translation">
              <textarea class="input" row="5" v-model="coupon.payload.text1[lang.default]" @focusout="setDefaultVal('text1')"></textarea>
              <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('text1')">
                <span class="blind">{{locale.language_specific_set}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
              </button>
            </div>
          </div>
          <!-- //제목 (display) -->
          <!-- 부제목 (display) -->
          <div class="mb15">
            <div class="innerTitle setLabel">{{locale.description}}</div>
            <div class="siteTitle translation">
              <textarea class="input" row="5" v-model="coupon.payload.text2[lang.default]" @focusout="setDefaultVal('text2')"></textarea>
              <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('text2')">
                <span class="blind">{{locale.language_specific_set}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
              </button>
            </div>
          </div>
          <!-- //부제목 (display) -->
          <!-- 쿠폰이미지 -->
          <div class="innerItem">
            <div class="innerTitle setLabel">{{locale.image}}</div>
            <div v-if="coupon.payload.image" class="bgThumb">
              <img :src="coupon.payload.image" alt="" />
              <button type="button" class="delThumb" @click="deleteImage(coupon.payload)"><img src="~@/assets/img/ico_close.svg" alt=""></button>
            </div>
            <div v-else><label class="btn btnFull btnWhite toUppercase">{{locale.upload}}<input type="file" @change="uploadImage(coupon.payload, $event)"></label></div>
          </div>
          <!-- //쿠폰이미지 -->
          <!-- 쿠폰사용 버튼 -->
          <div class="innerItem">
            <div class="innerTitle setLabel">
              <span class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="displayBtn" v-model="coupon.payload.displayBtn">
                <label for="displayBtn">{{locale.coupon_display_use}} - {{locale.coupon_display_button_guest}}</label>
              </span>
            </div>
          </div>
          <!-- //쿠폰사용 버튼 -->
          <!-- 쿠폰기한 -->
          <div class="innerItem">
            <p class="innerTitle setLabel">
              <span class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="isUseTerm" v-model="coupon.payload.useTerm">
                <label for="isUseTerm">{{locale.coupon_available_period}}</label>
              </span>
            </p>
            <div v-if="coupon.payload.useTerm">
              <datetime type="date"
                v-model="coupon.useAfter"
                input-class="input inlinInput"
                format="yyyy-LL-dd">
              </datetime> -
              <datetime type="date"
                v-model="coupon.useBefore"
                input-class="input inlinInput"
                :min-datetime="useBeforeMinDate"
                format="yyyy-LL-dd">
              </datetime>
            </div>
            <p v-else>{{locale.coupon_use_always}}</p>
          </div>
          <!-- //쿠폰기한 -->
          <!-- 사용 가능한 페이지 -->
          <div class="innerItem">
            <div class="innerTitle setLabel">
              <span class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="usePage" v-model="coupon.payload.usePage">
                <label for="usePage">{{locale.coupon_assign_page}}</label>
              </span>
            </div>
            <p class="sysMessage">{{locale.coupon_set_assign_page}}</p>
            <div v-if="coupon.payload.usePage">
              <div v-if="coupon.payload.usePageIds && coupon.payload.usePageIds.length > 0">
                <p v-for="page in coupon.payload.usePageIds" :key="page.pageId" class="mt5">
                  - {{page.title}}
                </p>
              </div>
              <p v-else>{{locale.link_page_nodata}}</p>
              <button type="button" class="btn btnFull mt10" @click="loadPageLayer = true">{{locale.select_page}}</button>
            </div>
          </div>
          <!-- //사용 가능한 페이지 -->
          <!-- 금액 변경 -->
          <div class="innerItem">
            <div class="innerTitle setLabel">
              <span class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="priceSale" v-model="coupon.payload.discount">
                <label for="priceSale">{{locale.sale}}</label><!-- {{locale.coupon_assign_page}} -->
              </span>
            </div>
            <p class="sysMessage">{{locale.message_discount_about_total_price}}</p>
            <div v-if="coupon.payload.discount">
              <select v-model="coupon.payload.discountType" class="input select inlineInput mr15" @change="discountValueInit">
                <option value="price">{{locale.discountamount}}</option>
                <option value="rate">{{locale.discountrate}}</option>
              </select>
              <span v-if="coupon.payload.discountType === 'price'">
                {{currency}}
                <input type="text" class="input sizeSm right ml5" :value="discountPrice" @input="checkDiscount($event, 'price')">
              </span>
              <span v-if="coupon.payload.discountType === 'rate'" class="ml5">
                <input type="text" class="input sizeSm right ml5" :value="discountRate" @input="checkDiscount($event, 'rate')">
                %
              </span>
              <!-- <input type="text" class="input sizeSm right ml5" v-model="coupon.payload.discountValue"> -->
            </div>
          </div>
          <!-- //금액 변경 -->
          <!-- 수량선택가능 -->
          <div class="innerItem">
            <div class="innerTitle setLabel">
              <span class="checkbox toCapitalize f_medium" :class="{disabled: coupon.payload.discountType === 'rate'}">
                <input
                  type="checkbox"
                  id="allowed_qty"
                  :disabled="coupon.payload.discountType === 'rate'"
                  v-model="coupon.payload.allowedQty">
                <label for="allowed_qty">{{locale.coupon_allowed_quantity}}</label>
              </span>
            </div>
            <p class="sysMessage">{{locale.message_coupon_allowed_quantity}}</p>
          </div>
          <!-- //수량선택가능 -->
          <!-- 식별코드 -->
          <div class="innerItem">
            <div class="innerTitle setLabel">{{locale.product_id}}</div>
            <input type="text" class="input" v-model="coupon.payload.pId">
          </div>
          <!-- //식별코드 -->
          <!-- 바코드 사용 -->
          <div class="innerItem setBarcode">
            <div class="innerTitle setLabel">
              <span class="checkbox toCapitalize f_medium">
                <input type="checkbox" id="useBarcode" v-model="coupon.payload.barcode">
                <label for="useBarcode">{{locale.coupon_display_barcode}}</label>
              </span>
              <p v-if="coupon.payload.barcode && (!coupon.payload.barcodeValue || coupon.payload.barcodeValue === '')" class="sysMessage colorRed">
                {{locale.coupon_barcode_value_nodata}}
              </p>
            </div>
            <div v-if="coupon.payload.barcode" class="barcodeBox">
              <select v-model="coupon.payload.barcodeType" class="input barcodeType">
                <option value="undefined">{{locale.barcode_type}}</option>
                <option v-for="barcode in barcodeType"
                  :key="barcode"
                  :value="barcode">
                <option value=""></option>
                  {{barcode}}
                </option>
              </select>
              <input type="text" v-model="coupon.payload.barcodeValue" class="input barcodeValue" :placeholder="locale.barcode_value">
            </div>
          </div>
          <!-- //바코드 사용 -->
          <!-- 카테고리 -->
          <div>
            <div class="innerTitle setLabel">{{locale.category}}
              <button type="button" @click="onSetCategoryOpen" class="setCategory"><img src="~@/assets/img/ico_setting.svg" alt="" /></button>
            </div>
            <ul class="couponCategories">
              <li v-for="category in getCategory" :key="category.id" class="mb5">
                <span class="checkbox">
                  <input type="checkbox" name="coupon_category" :id="`coupon_category_${category.id}`" :value="category.id" v-model="coupon.category">
                  <label :for="`coupon_category_${category.id}`">{{category.label}}</label>
                </span>
              </li>
            </ul>
          </div>
          <!-- //카테고리 -->
        </div>
        <!-- preview -->
        <div class="style">
          <div class="innerItem">
            <div class="innerTitle setLabel f_bold">{{locale.preview}}</div>
            <!-- 언어 선택 -->
            <div class="previewLang">
              <select v-model="previewLang" class="input inlineInput">
                <option v-for="lang in usableList" :key="lang.c"
                  :value="lang.c">
                  {{langName(lang.c)}}
                </option>
              </select>
              <p class="mt5 f_light colorGrey">{{langMessage}}</p>
            </div>
          </div>
          <!-- //언어 선택 -->
          <div class="couponItem" :data-type="couponType">
            <div v-show="hasImage" class="image"><img :src="coupon.payload.image" alt=""></div>
            <div class="titleBox">
              <pre class="title" v-if="coupon.payload.text1[displayLang].length > 0">{{coupon.payload.text1[displayLang]}}</pre>
              <pre class="describe" v-if="coupon.payload.text2[displayLang].length > 0">{{coupon.payload.text2[displayLang]}}</pre>
              <div type="button" v-if="coupon.payload.displayBtn" class="btn btnWhite btnFull">{{locale.coupon_use}}</div>
            </div>
            <div v-if="coupon.payload.barcode && coupon.payload.barcodeValue" class="barcode">
              <barcode
                :value="coupon.payload.barcodeValue"
                :options="barcodeOption" />
              <p class="barcodeValue">{{coupon.payload.barcodeValue}}</p>
            </div>
          </div>
        </div>
        <!-- //preview -->
      </div>
      <div class="btns mt30">
        <button v-if="coupon.cid" type="button" class="btn btnRed btnDel" @click="delCoupon">{{locale.delete}}</button>
        <button type="button" class="btn btnWhite" @click="close">{{locale.cancel}}</button>
        <button type="button" class="btn btnPrimary ml15" @click="onSave">{{locale.save}}</button>
      </div>
    </div>
    <!-- 언어별 세팅 -->
    <LangValue v-show="langValueLayer"
      :locale="locale"
      :textarea="isTextarea"
      :langValue="langValue"
      :title="locale.language_specific_set"
      @close="onLangValueClose" />
    <!-- //언어별 세팅 -->
    <!-- 쿠폰카테고리 세팅 -->
    <SetCategory v-show="setCategoryLayer"
      :locale="locale"
      @close="onSetCategoryClose" />
    <!-- //쿠폰카테고리 세팅 -->
    <!-- 페이지 선택 -->
    <CheckPage
      v-if="loadPageLayer"
      :submitOnly="true"
      :locale="locale"
      :checked="coupon.payload.usePageIds"
      @apply="usePageIds"
      @close="closePageLayer" />
    <!-- //페이지 선택 -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LangValue from '@/components/Util/LangValue'
import CheckPage from '@/components/Util/CheckPage'
import SetCategory from '@/components/Coupon/SetCategory'
import UTIL from '@/common/util'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import Datetime from 'vue-datetime/src/Datetime'
import moment from 'moment/moment'
import barcode from '@chenfengyuan/vue-barcode'

export default {
  name: 'CouponDetail',
  props: [
    'locale'
  ],
  components: {
    LangValue,
    SetCategory,
    datetime: Datetime,
    barcode,
    CheckPage
  },
  computed: {
    ...mapGetters({
      getSetInfo: 'coupon/getSetInfo',
      getCategory: 'coupon/getCategory',
      settingData: 'setting/getData'
    }),
    lang () {
      return this.settingData.lang
    },
    displayLang () {
      const defaultLang = this.lang.default
      const previewLang = this.previewLang
      const isTranslate = this.lang.manual.includes(previewLang)
      return isTranslate ? previewLang : defaultLang
    },
    currency () {
      const setting = this.settingData.currency
      const defaultCurrency = setting.default
      return setting.info.find(x => x.c === defaultCurrency).e
    },
    usableList () {
      return this.lang.info.filter(x => {
        return this.lang.usable.indexOf(x.c) !== -1
      })
    },
    langMessage () {
      const lang = this.lang
      const current = this.previewLang
      let message
      if (lang.manual.includes(current)) {
        message = null
      } else {
        message = this.locale.translate_auto_message
      }
      return message
    },
    hasText () {
      return !this.isEmptyStr(this.coupon.payload.text1[this.displayLang]) || this.isEmptyStr(this.coupon.payload.text2[this.displayLang])
    },
    hasImage () {
      return this.coupon.payload.image
    },
    couponType () {
      let type = '' // default : hasText && hasImage
      if (this.hasText && !this.hasImage) {
        type = 'type01'
      } else if (!this.hasText && this.hasImage) {
        type = 'type02'
      } else if (!this.hasText && !this.hasImage) {
        type = 'type03'
      }
      return type
    },
    useBeforeMinDate () {
      const useAfter = this.coupon.useAfter
      const plus1Day = useAfter && moment(useAfter).add(1, 'days')
      return plus1Day ? plus1Day.toISOString() : null
    }
  },
  watch: {
    discountPrice (val) {
      this.discountPrice = val.replace(/[^0-9.]/g, '')
      // .... 만 입력하게 될 경우 체크
      if (isNaN(parseFloat(val))) {
        this.discountPrice = ''
      }
      if (this.coupon.payload.discount && this.coupon.payload.discountType === 'price') {
        this.coupon.payload.discountValue = this.discountPrice
      }
    },
    discountRate (val) {
      this.discountRate = val.replace(/[^0-9.]/g, '')
      if (parseFloat(val) >= 100) {
        this.discountRate = '100'
      }
      // .... 만 입력하게 될 경우 체크
      if (isNaN(parseFloat(val))) {
        this.discountRate = ''
      }
      if (this.coupon.payload.discount && this.coupon.payload.discountType === 'rate') {
        this.coupon.payload.discountValue = this.discountRate
      }
    }
  },
  created () {
    this.$store.dispatch('coupon/getCategory').then((res) => {
      res = !res ? [] : res
      this.$store.commit('coupon/setCategory', res)
    })
  },
  mounted () {
    this.coupon = this._.cloneDeep(this.getSetInfo)
    this.previewLang = this.lang.default
    if (!this.coupon.payload.discountType) {
      this.coupon.payload.discountType = 'price'
    } else {
      if (this.coupon.payload.discountValue) {
        const type = this.coupon.payload.discountType
        const key = type.charAt(0).toUpperCase() + type.slice(1)
        this[`discount${key}`] = this.coupon.payload.discountValue
      }
    }
  },
  data () {
    return {
      coupon: null,
      discountPrice: 0,
      discountRate: 0,
      previewLang: '',
      isUseTerm: false,
      langValueLayer: false,
      langValue: {},
      langTarget: '',
      setCategoryLayer: false,
      isTextarea: true,
      barcodeType: [
        'CODE128',
        'EAN13',
        'EAN8',
        'UPC',
        'CODE39',
        'ITF14',
        'MSI',
        'Pharacode',
        'Codabar'
      ],
      barcodeOption: {
        displayValue: false,
        width: 1,
        height: 80,
        margin: 0
      },
      loadPageLayer: false,
      loadLinkInfo: false
    }
  },
  methods: {
    langName (c) {
      const code = `lang_${c}`
      const translate = this.lang.manual.includes(c) ? 'translate_manual' : 'translate_auto'
      const isDefault = this.lang.default === c ? `(${this.locale.setting_language_default})` : ''
      return `${this.locale[code]} - ${this.locale[translate]}${isDefault}`
    },
    onLangValueOpen (target) {
      this.langTarget = target
      this.langValueLayer = true
      this.langValue = this.coupon.payload[target]
      this.setDefaultVal(target)
    },
    onLangValueClose () {
      const target = this.langTarget
      this.coupon.payload[target] = this.langValue
      this.langValueLayer = false
      this.langValue = {}
    },
    onSetCategoryOpen () {
      this.setCategoryLayer = true
    },
    onSetCategoryClose () {
      this.setCategoryLayer = false
    },
    setDefaultVal (target) {
      const defaultLang = this.lang.default
      const fillLangs = UTIL.fillLangs(this.coupon.payload[target], this.coupon.payload[target][defaultLang])
      this.coupon.payload[target] = fillLangs
    },
    uploadImage (item, e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          item.image = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteImage (item) {
      item.image = null
    },
    isEmptyStr (str) {
      return regExp.replaceAllEmpty(str).length === 0
    },
    closePageLayer () {
      this.loadLinkInfo = true
      this.loadPageLayer = false
    },
    usePageIds (data) {
      this.coupon.payload.usePageIds = data
    },
    checkDiscount (e, type) {
      let value = e.target.value
      if (type === 'price') {
        this.discountPrice = value
      } else if (type === 'rate') {
        this.discountRate = value
      }
    },
    discountValueInit () {
      const data = this.coupon.payload
      if (data.discountType === 'rate') {
        if (data.allowedQty) {
          // alert('할인율이 적용되는 쿠폰은 수량을 선택할 수 없습니다.')
          alert(this.locale.message_coupon_rate_not_allowed_quantity)
          this.coupon.payload.allowedQty = false
        }
      }
    },
    delCoupon () {
      const cid = this.coupon.cid
      if (window.confirm(this.locale.confirm_delete_coupon)) {
        this.$store.commit('onLoading', true)
        this.$store.dispatch('coupon/delCoupon', cid).then((res) => {
          if (res === 'E_HAVE_UNUSED_COUNPON') {
            alert(this.locale.validate_coupon_delete_use)
            this.$store.commit('onLoading', false)
          } else {
            this.$store.dispatch('coupon/getCouponList').then((res) => {
              alert(this.locale.complete_delete)
              this.$emit('close')
              this.$store.commit('coupon/setPreview', { isPreview: false })
              this.$store.commit('coupon/initSetInfo')
              this.$store.commit('onLoading', false)
            })
          }
        })
      }
    },
    validateOnSave () {
      const checkTitle = isEmptyStr(this.coupon.title)
      const text1 = this.coupon.payload.text1
      const text2 = this.coupon.payload.text2
      const emptyText1 = Object.keys(text1).filter(x => !isEmptyStr(text1[x])).length === 0
      const emptyText2 = Object.keys(text2).filter(x => !isEmptyStr(text2[x])).length === 0
      const emptyImage = this.coupon.payload.image === null
      const checkEmpty = emptyImage && emptyText1 && emptyText2
      function isEmptyStr (str) {
        return regExp.replaceAllEmpty(str).length === 0
      }
      if (checkTitle) {
        alert(this.locale.validate_coupon_save_title)
        return false
      } else if (checkEmpty) {
        alert(this.locale.validate_coupon_save_required)
        return false
      } else {
        return true
      }
    },
    onSave () {
      // return false
      if (this.validateOnSave()) {
        const save = !this.coupon.cid ? 'coupon/createCoupon' : 'coupon/updateCoupon'
        const coupon = this._.cloneDeep(this.coupon)
        coupon.category = JSON.stringify(coupon.category)
        coupon.useBefore = coupon.payload.useTerm ? coupon.useBefore : moment().add(40, 'year') // 기간을 지정하지 않으면 40년 뒤
        this.$store.commit('onLoading', true)
        this.$store.dispatch(save, coupon).then((res) => {
          if (res && res.cid) {
            coupon.cid = res.cid
            setTimeout(() => {
              this.$store.dispatch('coupon/getCouponList').then((res) => {
                alert(this.locale.complete_save)
                this.$store.commit('coupon/setCouponInfo', coupon)
                this.$store.commit('onLoading', false)
              })
            }, 500)
          } else {
            alert(this.locale.unknown_error)
          }
        })
      }
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.isRequired {
  .innerTitle:before {
    content: "*";
    color: $color-red;
    line-height: 1;
  }
  .setLabel.innerTitle {
    padding-left: 1.5em;
    &:before {
      text-indent: 0.7em;
    }
  }
}
.setCategory {
  width: 18px;
  margin-left: 5px;
  font-size: 0;
  opacity: 0.4;
  &:hover {
    opacity: 0.8;
  }
}
.couponCategories {
  max-height: 10em;
  overflow: auto;
}
.vdatetime {
  display: inline-block;
  width: 120px;
  vertical-align: middle;
}
.bgThumb {
  position: relative;
  .uploadImg {
    display: block;
    padding: 60px 0;
    color: $color-grey;
    font-size: $f-z-default;
    background-color: $bg-default;
    cursor: pointer;
  }
  .hasImg {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 0.5em 0;
    font-size: 0.85em;
    color: $color-dgrey;
    opacity: 0;
    box-shadow: 0 0 3px rgba(0,0,0,0.2);
    z-index: -1;
    transition: all 0.3s;
  }
  &:hover .hasImg {
    display: block;
    font-size: $f-z-default;
    opacity: 0.7;
    z-index: 1;
  }
}
.setBarcode .sysMessage {
  margin-top: 0;
  color: $color-red;
}
.barcodeBox {
  display: flex;
  .barcodeType {
    width: 40%;
  }
  .barcodeValue {
    width: calc(60% - 10px);
    margin-left: 10px;
  }
}
.layer {
  .inner {
    max-width: 800px;
  }
}
.couponDetail {
  display: flex;
  max-height: 100%;
  overflow: hidden;
  .info {
    flex: 1;
    overflow: auto;
    padding-right: 5px;
  }
  .style {
    overflow: auto;
    width: 420px;
    padding-left: 60px;
    padding-right: 5px;
  }
}
.btns {
  position: relative;
  text-align: center;
  .btnDel {
    position: absolute;
    top: 0;
    left: 0;
    min-width: 0;
  }
}
</style>
